// Canonical implementation now lives in src/Utils/orderLineKey.js (so non-payment
// callers — e.g. the Billingo invoicing helpers — can reuse it without a
// Utils -> Pages dependency). Re-exported here for the existing payment-side
// imports.
import getOrderLineKeyImpl from '../../../Utils/orderLineKey';

export const getOrderLineKey = getOrderLineKeyImpl;
export default getOrderLineKeyImpl;
